import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FocusTrap } from '../../helpers/FocusTrap';
import { Modal as Element } from './Elements';
export var ModalSize;
(function (ModalSize) {
    ModalSize["FitContent"] = "fit-content";
    ModalSize["Small"] = "380px";
    ModalSize["Medium"] = "580px";
    ModalSize["Large"] = "640px";
})(ModalSize || (ModalSize = {}));
const ModalBase = React.memo(({ container = document.body, size = ModalSize.Medium, isOpen, onClose, children, withClose, hideBackdrop, ariaLabelledBy, ariaDescribedBy, }) => {
    const [isOpenLocally, setIsOpenLocally] = useState(isOpen);
    useEffect(() => {
        if (isOpen !== isOpenLocally) {
            if (!isOpen) {
                setTimeout(() => setIsOpenLocally(false), 250);
            }
            else {
                setIsOpenLocally(true);
            }
        }
    }, [isOpen, isOpenLocally]);
    const handleDialogClose = useCallback(() => {
        onClose?.();
        if (isOpenLocally) {
            setIsOpenLocally(false);
        }
    }, [isOpenLocally, onClose]);
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleDialogClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, handleDialogClose]);
    return (isOpenLocally &&
        createPortal(React.createElement(Element.Wrapper, { "$open": isOpen ?? false },
            !hideBackdrop && React.createElement(Element.Backdrop, { "$open": isOpen ?? false }),
            React.createElement(Element.Dialog, { "$size": size, open: isOpen ?? false, onClose: handleDialogClose, "aria-modal": "true", "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy },
                React.createElement(FocusTrap, null,
                    (withClose ?? true) && (React.createElement(Element.Close, { variant: "muted", size: "small", onClick: handleDialogClose, "$isFixed": true })),
                    React.createElement(Element.Inner, null, children)))), container));
});
export const Modal = Object.assign(ModalBase, Element);
//# sourceMappingURL=Base.js.map